//https://modularfirebase.web.app/common-use-cases/storage/
import { initializeApp } from "firebase/app";

import etapa from "@/constants/etapaCompra";
import {
  FIREBASE_CHAVE_SERVER,
  FUNCTIONS_URL,
  RECAPTCHA_ENTERPRISE_KEY,
  APPCHECK_DEBUG_TOKEN,
  STORAGE_MOLDURA,
} from "@/constants/keys";
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
  getToken,
} from "firebase/app-check";

import store from "@/store/index";
import {
  connectAuthEmulator,
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { getDatabase, onValue, ref, update } from "firebase/database";
import {
  addDoc,
  collection,
  connectFirestoreEmulator,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  increment,
  query,
  runTransaction,
  serverTimestamp,
  setDoc,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { getStorage, ref as storageRef, uploadString } from "firebase/storage";
import {
  COLLECTION_COMPRAS,
  COLLECTION_CUPONS,
  COLLECTION_PERSONALIZA_TOTEM,
  COLLECTION_PRECOS,
  COLLECTION_TOTEM,
} from "./collectionsNames";
import router from "@/router";
import { HOME_CONFIG_CACHE_BASE } from "@/store/homeConfig";
import { normalizaMoldurasEvento } from "@/constants/types/molduraEvento";
import { comTimeout } from "@/utils/promiseTimeout";

export const app = initializeApp(FIREBASE_CHAVE_SERVER);

// Emuladores locais (Auth + Firestore), só no modo e2e-emulador. Os emuladores
// não pedem App Check, então ele fica desligado nesse modo.
const USA_EMULADOR = process.env.VUE_APP_FIREBASE_EMULADOR === "true";

// App Check — deve ser inicializado antes de qualquer uso do SDK
if (APPCHECK_DEBUG_TOKEN) {
  // eslint-disable-next-line no-undef
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = APPCHECK_DEBUG_TOKEN;
}
export const appCheck =
  RECAPTCHA_ENTERPRISE_KEY && !USA_EMULADOR
    ? initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(RECAPTCHA_ENTERPRISE_KEY),
        isTokenAutoRefreshEnabled: true,
      })
    : null;

export const storage = getStorage(app);
export const storageInst = getStorage(app);
// export const storageMolduras = getStorage(app);
export const storageMolduras = getStorage(app, STORAGE_MOLDURA);
export const auth = getAuth();
export const db = getFirestore(app);

if (USA_EMULADOR) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8181);
}

// Resolve com o usuário logado, esperando o login acontecer por até `ms`.
// As regras só deixam o totem gravar em `erros` depois do login; sem esperar,
// um erro do boot (antes do /init autenticar) era recusado e se perdia.
export function aguardarLogin(ms = 60000) {
  if (auth.currentUser) return Promise.resolve(auth.currentUser);
  return new Promise((resolve, reject) => {
    let cancelar = () => {};
    const timer = setTimeout(() => {
      cancelar();
      reject(new Error("Totem não autenticado a tempo"));
    }, ms);
    cancelar = onAuthStateChanged(auth, (user) => {
      if (!user) return;
      clearTimeout(timer);
      cancelar();
      resolve(user);
    });
  });
}

/** Versão observada no próprio bundle do Totem, publicada ao entrar na Home. */
export function reportarVersaoApp(versao = process.env.VUE_APP_VERSION) {
  const totemId = store.getters["totem/getTotem"]?.id;
  const valor = String(versao || "").trim();
  if (!totemId || !valor) return Promise.resolve(false);
  return setDoc(
    doc(db, COLLECTION_TOTEM, totemId),
    {
      versao_app: valor,
      versao_app_atualizada_em: serverTimestamp(),
      // Somente bundles que gravam visitas_telas publicam esta capacidade.
      // O monitor no Backend não infere ausência de venda a partir de uma
      // versão antiga sem telemetria da tela de agradecimento.
      visitas_telas_capaz: true,
    },
    { merge: true }
  ).then(() => true);
}

export async function getAppCheckToken() {
  if (!appCheck) return null;
  try {
    const result = await getToken(appCheck);
    return result.token;
  } catch (_) {
    return null;
  }
}

//Actions
export function getCurrentUser() {
  let user = auth.currentUser;
  if (user !== null) {
    return user;
  } else {
    return null;
  }
}

let authStateListenerRegistered = false;

export async function handleAuth() {
  if (authStateListenerRegistered) return;
  authStateListenerRegistered = true;

  onAuthStateChanged(auth, (user) => {
    if (user) {
      console.log("conected firebase");
      //deliveryDataTotem(user);
    } else {
      console.log("disconected firebase");
      //store.commit("totem/setTotem", {});
    }
  });
}

export async function loadPrecos() {
  let totemUID = store.getters["totem/getTotem"].id;
  const precosRef = collection(db, COLLECTION_PRECOS);
  const q = query(precosRef, where("totem_uid", "==", totemUID));
  const querySnapshot = await getDocs(q);
  const array = [];
  await querySnapshot.forEach((snapdoc) => {
    array.push({ ...snapdoc.data(), id: snapdoc.id });
  });

  store.commit(
    "precos/setPrecos",
    array.sort((a, b) => a.qtde_foto - b.qtde_foto)
  );
}

export async function buscarCupomPrivado(codigo) {
  try {
    const totemID = store.getters["totem/getTotem"].id;
    const tipoFoto = store.getters["compra/getCompra"].tipo_foto;
    const cupomsRef = collection(db, COLLECTION_CUPONS);

    const q = query(
      cupomsRef,
      where("ativo", "==", true),
      where("codigo", "==", codigo)
    );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return {
        sucesso: false,
        erro: "cupom_nao_encontrado",
        mensagem: "Cupom não encontrado",
      };
    }

    const cupomDoc = querySnapshot.docs[0];
    const cupomData = cupomDoc.data();

    // Verifica se o cupom está expirado
    if (cupomData.dataValidade) {
      let dataValidade = cupomData.dataValidade.toDate
        ? cupomData.dataValidade.toDate()
        : new Date(cupomData.dataValidade.seconds * 1000);
      dataValidade.setHours(23, 59, 59, 999); // Define para o final do dia
      if (dataValidade < new Date()) {
        return {
          sucesso: false,
          erro: "cupom_expirado",
          mensagem: "Cupom expirado",
        };
      }
    }

    // Verifica se o cupom ainda tem usos disponíveis
    if (cupomData.limiteUso !== null && cupomData.limiteUso !== undefined) {
      if (cupomData.contadorUso >= cupomData.limiteUso) {
        return {
          sucesso: false,
          erro: "cupom_sem_usos",
          mensagem: "Cupom sem usos disponíveis",
        };
      }
    }

    if (
      tipoFoto &&
      cupomData.tiposFotoAplicaveis &&
      cupomData.tiposFotoAplicaveis.length > 0
    ) {
      if (!cupomData.tiposFotoAplicaveis.includes(tipoFoto)) {
        return {
          sucesso: false,
          erro: "cupom_tipo_foto_invalido",
          mensagem: "Este cupom não é válido para o tipo de foto selecionado",
        };
      }
    }

    // Se o cupom é global, inclui
    if (cupomData.global) {
      return {
        sucesso: true,
        cupom: {
          id: cupomDoc.id,
          ...cupomData,
        },
      };
    } else {
      // Se não é global, verifica se o totem existe na subcoleção
      const totemDocRef = doc(
        db,
        COLLECTION_CUPONS,
        cupomDoc.id,
        "totens",
        totemID
      );
      const totemDocSnap = await getDoc(totemDocRef);

      if (totemDocSnap.exists()) {
        return {
          sucesso: true,
          cupom: {
            id: cupomDoc.id,
            ...cupomData,
          },
        };
      } else {
        // Totem não está na lista de totens autorizados
        return {
          sucesso: false,
          erro: "cupom_nao_aplicavel_neste_totem",
          mensagem: "Este cupom não pode ser utilizado neste totem",
        };
      }
    }
  } catch (error) {
    return {
      sucesso: false,
      erro: "erro_interno",
      mensagem: "Erro ao processar cupom",
    };
  }
}

export async function incrementarUsosCupom(cupomId) {
  try {
    const cupomRef = doc(db, COLLECTION_CUPONS, cupomId);
    await updateDoc(cupomRef, {
      contadorUso: increment(1),
      ultimo_uso: Timestamp.fromDate(new Date()),
    });
    return true;
  } catch (error) {
    return false;
  }
}

export async function iniciarCompra(
  callbackSucesso,
  callbackErro,
  options = {}
) {
  try {
    let totem = store.getters["totem/getTotem"];
    const fixedTotemId = totem.id;
    const deviceUid = options.purchaseId ? auth.currentUser?.uid : null;
    const assertFixedContext = () => {
      if (
        options.purchaseId &&
        (!deviceUid ||
          auth.currentUser?.uid !== deviceUid ||
          store.getters["totem/getTotem"]?.id !== fixedTotemId)
      )
        throw new Error("Sessão alterada durante o atendimento.");
    };
    assertFixedContext();
    if (options.totemId && options.totemId !== fixedTotemId)
      throw new Error("Totem alterado durante o atendimento.");
    let compra = {
      data_hora: Timestamp.fromDate(new Date()),
      valor: 0,
      codigo_gateway_pag: null,
      tipo_foto: null,
      qtde_foto: 0,
      etapa: etapa.TIPO_FOTO,
      keep_alive: Timestamp.fromDate(new Date()),
      totem_id: fixedTotemId,
      code: null,
      cupom: null,
    };

    let compraRef;
    if (options.purchaseId) {
      if (!/^[A-Za-z0-9_-]{1,128}$/.test(options.purchaseId))
        throw new Error("Compra inválida.");
      compraRef = doc(db, COLLECTION_COMPRAS, options.purchaseId);
      compra = await runTransaction(db, async (transaction) => {
        assertFixedContext();
        const existente = await transaction.get(compraRef);
        assertFixedContext();
        if (existente.exists()) {
          if (existente.data().totem_id !== fixedTotemId)
            throw new Error("Compra de outro Totem.");
          return existente.data();
        }
        transaction.set(compraRef, compra);
        return compra;
      });
    } else {
      compraRef = await addDoc(collection(db, COLLECTION_COMPRAS), compra);
    }
    assertFixedContext();
    if (store.getters["totem/getTotem"]?.id !== fixedTotemId)
      throw new Error("Totem alterado durante o atendimento.");

    if (compraRef && compraRef.id) {
      compra.id = compraRef.id;
      totem.compra_atual = compra;
      totem.keep_alive = Timestamp.fromDate(new Date());
      store.commit("totem/setTotem", totem);
      store.commit("compra/setCompra", compra);
      let totemRef = doc(db, COLLECTION_TOTEM, fixedTotemId);
      await setDoc(
        totemRef,
        { compra_atual: compra, keep_alive: totem.keep_alive },
        { merge: true }
      );
      assertFixedContext();
      callbackSucesso();
    } else {
      callbackErro();
    }
  } catch (e) {
    console.log("Erro ao iniciar uma compra catch: ", e);
    callbackErro();
  }
}

export async function rebaseCompraAtual() {
  let compraID = store.getters["compra/getCompra"].id;
  let docRef = doc(db, COLLECTION_COMPRAS, compraID);
  let docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    store.commit("compra/setCompra", docSnap.data());
  } else {
    console.log("Compra não existe!");
    store.commit("setModal", {
      tipo: "info",
      mensagem: "Erro! Compra não existe.",
      toggle: true,
    });
  }
}

export function setEtapaCompraLocal(payload_etapa) {
  //caso necessario.
  let compra = store.getters["compra/getCompra"];
  compra.etapa = payload_etapa;
  store.commit("compra/setCompra", compra);
}

function semContadoresDeVisita(compra) {
  // O listener/rebase pode trazer os incrementos remotos para a store. Uma
  // escrita posterior da compra inteira não deve sobrescrever esses valores
  // com um snapshot antigo; só screenVisits grava este campo.
  const dadosCompra = { ...compra };
  delete dadosCompra.visitas_telas;
  delete dadosCompra.visitas_telas_versao;
  delete dadosCompra.abandono_timeout;
  delete dadosCompra.abandono_timeout_versao;
  return dadosCompra;
}

// Somente comandos de escrita substituem uma intenção. Snapshots/telemetria
// podem mudar a store sem desfazer uma transição explícita (caso do editor).
let intencaoCompraAtual = null;

function registrarIntencaoCompra(compraId, totemId) {
  const intencao = { compraId, totemId, uid: auth.currentUser?.uid || null };
  intencaoCompraAtual = intencao;
  return intencao;
}

function intencaoCompraVigente(intencao) {
  return (
    intencaoCompraAtual === intencao &&
    store.getters["compra/getCompra"]?.id === intencao.compraId &&
    store.getters["totem/getTotem"]?.id === intencao.totemId &&
    (auth.currentUser?.uid || null) === intencao.uid
  );
}

// new method renovate;
export async function updateCompraInterface(CompraAlterada) {
  const totemID = store.getters["totem/getTotem"].id;
  const compraID = store.getters["compra/getCompra"].id;
  registrarIntencaoCompra(compraID, totemID);
  const compraRef = doc(db, COLLECTION_COMPRAS, compraID);
  const totemRef = doc(db, COLLECTION_TOTEM, totemID);
  CompraAlterada.keep_alive = Timestamp.fromDate(new Date());
  store.commit("compra/setCompra", CompraAlterada);

  await setDoc(
    totemRef,
    {
      keep_alive: Timestamp.fromDate(new Date()),
      compra_atual: CompraAlterada,
    },
    { merge: true }
  );
  await setDoc(compraRef, semContadoresDeVisita(CompraAlterada), {
    merge: true,
  });
  return;
}
export async function setCompra(compra_alterada) {
  registrarIntencaoCompra(
    compra_alterada.id,
    store.getters["totem/getTotem"]?.id
  );
  const compraRef = doc(db, COLLECTION_COMPRAS, compra_alterada.id);
  compra_alterada.keep_alive = Timestamp.fromDate(new Date());
  return await setDoc(compraRef, semContadoresDeVisita(compra_alterada), {
    merge: true,
  });
}
export async function setEtapaCompra(_etapa) {
  let compra = store.getters["compra/getCompra"];
  let totem = store.getters["totem/getTotem"];
  compra.etapa = _etapa;
  compra.keep_alive = Timestamp.fromDate(new Date());
  // Um snapshot de telemetria pode atualizar a etapa local enquanto a escrita
  // do Totem aguarda confirmação. Preserve a transição solicitada em um payload
  // separado do Vuex, para não gravar a etapa anterior de volta em compras.
  const dadosCompra = semContadoresDeVisita(compra);
  store.commit("compra/setCompra", compra);
  const compraRef = doc(db, COLLECTION_COMPRAS, compra.id);
  const totemRef = doc(db, COLLECTION_TOTEM, totem.id);
  const intencao = registrarIntencaoCompra(compra.id, totem.id);

  // Criar uma versão da compra sem as fotos para o totem (evitar limite de 1MB)
  const compraParaTotem = { ...compra };
  if (compraParaTotem.fotos) {
    delete compraParaTotem.fotos; // Remover fotos do objeto para o totem
  }

  // A confirmação do Totem continua precedendo a escrita que pode navegar
  // para pagamento/impressão. Um batch anteciparia o snapshot local da compra.
  try {
    await setDoc(
      totemRef,
      {
        keep_alive: Timestamp.fromDate(new Date()),
        compra_atual: compraParaTotem,
      },
      { merge: true }
    );
  } catch (error) {
    // Uma recusa de uma intenção antiga não deve acionar o fallback de uma
    // tela já superada. A falha da intenção atual continua chegando ao chamador.
    if (intencaoCompraVigente(intencao)) throw error;
    return;
  }
  if (!intencaoCompraVigente(intencao)) return;
  return setDoc(compraRef, dadosCompra, { merge: true });
}

// O Totem só chama este caminho quando a configuração dispensou o pagamento.
// O campo entra na mesma escrita da etapa e na store antes que outro listener
// possa regravar a compra. Chamadas repetidas mantêm o booleano true.
export function pularPagamentoParaImpressao() {
  const compra = store.getters["compra/getCompra"];
  if (
    store.getters["totem/getTotem"]?.config?.pular_etapa_pagamento === true &&
    compra.pago !== true
  ) {
    compra.pagamento_desativado_na_compra = true;
    store.commit("compra/setCompra", compra);
  }
  return setEtapaCompra(etapa.IMPRESSAO);
}

// O serviço local confirma que recebeu/processou o trabalho, não que o papel
// físico saiu. A transação preserva o primeiro aceite se houver retry.
export function registrarImpressaoConfirmada(compraId, quantidadeEnviada) {
  if (!compraId)
    return Promise.reject(new Error("Compra sem ID para telemetria."));
  if (!Number.isInteger(quantidadeEnviada) || quantidadeEnviada <= 0) {
    return Promise.reject(
      new Error("Quantidade enviada inválida para telemetria.")
    );
  }
  const compraRef = doc(db, COLLECTION_COMPRAS, compraId);
  return runTransaction(db, async (transacao) => {
    const snapshot = await transacao.get(compraRef);
    if (!snapshot.exists())
      throw new Error("Compra não encontrada para telemetria.");
    // Compras pagas e impressões liberadas sem pagamento seguem o mesmo funil.
    // Não registrar um trabalho que não tenha nenhuma dessas autorizações.
    if (
      snapshot.data().pago !== true &&
      snapshot.data().pagamento_desativado_na_compra !== true
    )
      return;
    if (snapshot.data().impressao_confirmada_em) return;
    transacao.update(compraRef, {
      impressao_confirmada_em: serverTimestamp(),
      impressao_qtde_fotos_enviadas: quantidadeEnviada,
    });
  });
}

export async function setTypePhotoCompra(_tipo) {
  const compra = store.getters["compra/getCompra"];
  compra.tipo_foto = _tipo;
  store.commit("compra/setCompra", compra);
  const compraRef = doc(db, COLLECTION_COMPRAS, compra.id);
  return setDoc(compraRef, { tipo_foto: _tipo }, { merge: true });
}

export async function fastUpdate(compra_completa) {
  const compraRef = doc(db, COLLECTION_COMPRAS, compra_completa.id);
  store.commit("compra/setCompra", compra_completa);
  return setDoc(compraRef, semContadoresDeVisita(compra_completa), {
    merge: true,
  });
}

// Chama uma Cloud Function autenticada (Bearer + App Check)
//
// TODAS as etapas aqui têm timeout. Sem isso, uma falha de rede ou um token de
// App Check que não é emitido deixa a promise pendurada para sempre — e quem
// chamou (ex.: a tela do QR Code) fica no loading eternamente.
const TIMEOUT_TOKEN_MS = 10000;
const TIMEOUT_FUNCTION_MS = 20000;

async function callFunction(name, data) {
  const user = auth.currentUser;
  if (!user) throw new Error("Usuário não autenticado.");

  const [idToken, appCheckResult] = await Promise.all([
    comTimeout(user.getIdToken(), {
      ms: TIMEOUT_TOKEN_MS,
      rotulo: "getIdToken",
    }),
    // O token de App Check é opcional: se demorar ou falhar, seguimos sem ele
    // e deixamos o servidor decidir. O que não pode é travar a chamada.
    appCheck
      ? comTimeout(getAppCheckToken(), {
          ms: TIMEOUT_TOKEN_MS,
          rotulo: "appCheck.getToken",
        })
          .then((token) => (token ? { token } : null))
          .catch(() => null)
      : Promise.resolve(null),
  ]);

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${idToken}`,
  };
  if (appCheckResult?.token) {
    headers["X-Firebase-AppCheck"] = appCheckResult.token;
  }

  // AbortController encerra a conexão de fato; o comTimeout garante a rejeição
  // mesmo se o abort não existir ou não propagar.
  const controller =
    typeof AbortController !== "undefined" ? new AbortController() : null;
  const opcoesFetch = {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  };
  if (controller) opcoesFetch.signal = controller.signal;

  const response = await comTimeout(
    fetch(`${FUNCTIONS_URL}${name}`, opcoesFetch),
    { ms: TIMEOUT_FUNCTION_MS, rotulo: `cloud function ${name}` }
  ).catch((erro) => {
    if (erro.isTimeout && controller) controller.abort();
    throw erro;
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw Object.assign(
      new Error(err.message || "Erro na Cloud Function"),
      err
    );
  }
  return response.json();
}

export async function removeCodeFirebase(codigoCapturado) {
  const code = codigoCapturado === undefined
    ? store.getters["compra/getCompra"].code
    : codigoCapturado;
  if (!code || code === "") {
    return false;
  }
  try {
    await callFunction("removerCode", { code });
  } catch (e) {
    console.error("Erro ao remover code:", e);
  }
}

// Upload helpers used by selfie flow
export async function uploadImageStorage(dataUrl, path) {
  const ref = storageRef(storage, path);
  // dataUrl is a base64 data URL (e.g., "data:image/png;base64,...")
  return uploadString(ref, dataUrl, "data_url");
}

export async function createCode() {
  const compra = store.getters["compra/getCompra"];
  const { code } = await callFunction("criarCode", { compra_id: compra.id });
  compra.code = code;
  await fastUpdate(compra);
  return code;
}

export async function registrarRibbon(value) {
  const totem = store.getters["totem/getTotem"];
  let resultTotal = totem.contadores.countRibbonTotal + value;
  let resultReduce = totem.contadores.countRibbon - value;
  if (!resultTotal || resultTotal < 0) {
    resultTotal = value;
  }
  if (!resultReduce || resultReduce < 0) {
    resultReduce = 0;
  }
  const refTotem = doc(db, COLLECTION_TOTEM, totem.id);
  await setDoc(
    refTotem,
    {
      contadores: {
        countRibbon: resultReduce,
        countRibbonTotal: resultTotal,
      },
    },
    {
      merge: true,
    }
  );
}

export async function setQtdValorCompra(_qtde_foto, _valor, _codigo_produto, precoId) {
  const compra = store.getters["compra/getCompra"];
  compra.qtde_foto = _qtde_foto;
  compra.valor = _valor;
  compra.codigo_produto = _codigo_produto || null;
  if (precoId) compra.preco_id = precoId;
  store.commit("compra/setCompra", compra);
  const compraRef = doc(db, COLLECTION_COMPRAS, compra.id);
  await setDoc(
    compraRef,
    {
      qtde_foto: _qtde_foto,
      valor: _valor,
      codigo_produto: _codigo_produto || null,
      ...(precoId ? { preco_id: precoId } : {}),
    },
    { merge: true }
  );
}

// ── clean_cache = comando de MANUTENÇÃO (tela de manutenção do gestão) ─────────
// NÃO é usado para atualização automática da Home. Ao receber o comando, o totem
// LIMPA o cache local da Home, pede ao service worker que procure uma versão
// nova do app e RECARREGA a página — mas só com o totem OCIOSO na Home; se
// estiver no meio de uma compra, o reload é ADIADO até voltar à Home.
//
// A flag só é desarmada (`false`) DEPOIS do reload, no primeiro evento da
// página nova: é isso que o gestão mostra como "OK". Desarmar antes fazia o
// gestão mostrar "OK" com o reload ainda adiado, e o write podia se perder no
// próprio reload. O marcador no sessionStorage diz à página nova que ela é
// fruto do comando — sem ele, a flag ainda `true` dispararia outro reload.
const HOME_ROUTE_PATH = "/cabine/home";
const MARCADOR_RELOAD_KEY = "cleanCacheReloadPendenteAck";
// Cobre o download do SW novo e o precache dele; fica abaixo dos 60s em que o
// gestão espera a confirmação.
const TIMEOUT_BUSCA_VERSAO_MS = 20000;

let cleanCacheBoundTotem = null; // totemId já assinado (evita assinaturas duplicadas)
let cleanCacheUnsub = null;
let reloadPendente = false;
let routeHookRegistrado = false;
let cleanCacheGeracao = 0;

export function pararListenerCleanCache() {
  const cancelar = cleanCacheUnsub;
  cleanCacheGeracao += 1;
  if (reloadPendente) {
    try {
      sessionStorage.removeItem(MARCADOR_RELOAD_KEY);
    } catch (_) {
      // Storage indisponível: o cancelamento local continua válido.
    }
  }
  cleanCacheUnsub = null;
  cleanCacheBoundTotem = null;
  reloadPendente = false;

  if (typeof cancelar === "function") cancelar();
}

// Versão completa do Chrome (ex.: "128.0.6613.120"). O User-Agent só traz a
// major (o Chrome zera o resto desde a redução do UA), por isso a fonte
// principal é o userAgentData; o UA fica de reserva.
async function versaoChrome() {
  try {
    const uaData = typeof navigator !== "undefined" && navigator.userAgentData;
    if (uaData && uaData.getHighEntropyValues) {
      const { fullVersionList } = await comTimeout(
        uaData.getHighEntropyValues(["fullVersionList"]),
        { ms: 3000, rotulo: "versão do Chrome" }
      );
      const chrome = (fullVersionList || []).find(
        (m) => m.brand === "Google Chrome" || m.brand === "Chromium"
      );
      if (chrome) return chrome.version;
    }
  } catch (_) {
    // segue para o User-Agent
  }
  try {
    const m = /Chrome\/([\d.]+)/.exec(navigator.userAgent);
    return m ? m[1] : null;
  } catch (_) {
    return null;
  }
}

// Informações da cabine mostradas na tela de Manutenção do gestão, gravadas
// junto com a confirmação do clean_cache. Falhar aqui nunca impede o ack.
async function infoSistema() {
  return {
    versao_sistema: process.env.VUE_APP_VERSION || null,
    versao_chrome: await versaoChrome(),
    dt_versao_sistema: new Date().toISOString(),
  };
}

async function desarmarFlag(db, totemId, geracao = cleanCacheGeracao) {
  let info = {};
  try {
    info = await infoSistema();
  } catch (_) {
    // sem info: desarma do mesmo jeito
  }
  if (geracao !== cleanCacheGeracao || cleanCacheBoundTotem !== totemId) return;
  return update(ref(db, `${totemId}`), { ...info, clean_cache: false }).catch(
    (e) => {
      // eslint-disable-next-line no-console
      console.error("clean_cache: falha ao desarmar a flag:", e);
    }
  );
}

// Lê e APAGA o marcador: só vale para o primeiro evento da página nova.
function consumirMarcadorReload() {
  let marcado = false;
  try {
    marcado = !!sessionStorage.getItem(MARCADOR_RELOAD_KEY);
  } catch (_) {
    return false;
  }
  try {
    sessionStorage.removeItem(MARCADOR_RELOAD_KEY);
  } catch (_) {
    // não conseguiu apagar: o marcador lido continua valendo para esta página
  }
  return marcado;
}

// Grava o marcador e confere a leitura: `false` quando não há sessionStorage.
function marcarReload() {
  try {
    sessionStorage.setItem(MARCADOR_RELOAD_KEY, "1");
    return sessionStorage.getItem(MARCADOR_RELOAD_KEY) === "1";
  } catch (_) {
    return false;
  }
}

async function recarregar(db, totemId, geracao = cleanCacheGeracao) {
  if (geracao !== cleanCacheGeracao || cleanCacheBoundTotem !== totemId) return;
  // Sem sessionStorage a página nova não saberia que já recarregou e entraria
  // em loop: desarma ANTES do reload (comportamento antigo) e espera o write.
  if (!marcarReload()) {
    await comTimeout(desarmarFlag(db, totemId, geracao), {
      ms: 5000,
      rotulo: "desarmar clean_cache",
    }).catch(() => {});
  }
  if (geracao !== cleanCacheGeracao || cleanCacheBoundTotem !== totemId) return;
  location.reload();
}

// Pede ao service worker que procure um deploy novo e, se houver, espera o SW
// novo assumir (skipWaiting/clientsClaim): o `update()` resolve quando ele
// COMEÇA a instalar, e recarregar nesse ponto ainda serviria a versão antiga.
// Quando ele assume, o registerServiceWorker.js pode recarregar antes de nós
// (controllerchange) — por isso o marcador é gravado antes desta busca. Nunca
// bloqueia além do timeout nem impede o reload.
async function buscarNovaVersao() {
  try {
    if (typeof navigator === "undefined" || !navigator.serviceWorker) return;
    const registro = await navigator.serviceWorker.getRegistration();
    if (!registro) return;
    await comTimeout(
      registro
        .update()
        .then(() => esperarAtivacao(registro.installing || registro.waiting)),
      {
        ms: TIMEOUT_BUSCA_VERSAO_MS,
        rotulo: "buscar nova versão (clean_cache)",
      }
    );
  } catch (_) {
    // sem rede, SW recusado ou timeout: recarrega com a versão atual
  }
}

function esperarAtivacao(sw) {
  if (!sw) return Promise.resolve();
  return new Promise((resolve) => {
    const conferir = () => {
      if (sw.state === "activated" || sw.state === "redundant") {
        sw.removeEventListener("statechange", conferir);
        resolve();
      }
    };
    sw.addEventListener("statechange", conferir);
    conferir();
  });
}

function totemOcioso() {
  return !!router.currentRoute && router.currentRoute.path === HOME_ROUTE_PATH;
}

// Remove TODAS as entradas de cache da Home (a global e as por totem EVENTO),
// inclusive de versões antigas do schema — o comando de manutenção deve limpar
// tudo, sem depender de qual fonte está ativa agora.
function limparCacheHome() {
  try {
    const chaves = [];
    for (let i = 0; i < localStorage.length; i++) {
      const chave = localStorage.key(i);
      if (chave && chave.startsWith(HOME_CONFIG_CACHE_BASE)) chaves.push(chave);
    }
    chaves.forEach((chave) => localStorage.removeItem(chave));
  } catch (_) {
    // ignora erros de storage
  }
}

function garantirRouteHook(db) {
  if (routeHookRegistrado) return;
  routeHookRegistrado = true;
  // vue-router 3.2 não retorna removedor em afterEach; usamos uma flag persistente
  router.afterEach((to) => {
    if (reloadPendente && cleanCacheBoundTotem && to.path === HOME_ROUTE_PATH) {
      reloadPendente = false;
      recarregar(db, cleanCacheBoundTotem);
    }
  });
}

async function aplicarOuAdiarReload(db, totemId, geracao) {
  // Um segundo `true` enquanto o primeiro ainda espera não empilha nada.
  if (reloadPendente) return;
  reloadPendente = true;

  // Limpa o cache local para a próxima carga da Home vir fresca do Firestore
  limparCacheHome();
  // Marca ANTES da busca: se houver deploy novo, quem recarrega pode ser o
  // registerServiceWorker.js, e a página nova precisa saber que é o reload
  // pedido. Qualquer reload a partir daqui cumpre o comando.
  marcarReload();
  await buscarNovaVersao();
  // A identidade pode ter sido removida/trocada enquanto o SW era procurado.
  if (geracao !== cleanCacheGeracao || cleanCacheBoundTotem !== totemId) return;

  // Ociosidade conferida DEPOIS da busca: um cliente pode ter começado uma
  // compra enquanto ela rodava.
  if (totemOcioso()) {
    reloadPendente = false;
    await recarregar(db, totemId, geracao);
  } else {
    // Sessão em andamento: adia o reload até o totem voltar para a Home
    garantirRouteHook(db);
  }
}

export async function listenerCleanCache(totemId) {
  const db = getDatabase(app);

  // O onSnapshot do totem chama isto a cada mudança — assina só uma vez por totem.
  if (cleanCacheBoundTotem === totemId && cleanCacheUnsub) return;
  pararListenerCleanCache();
  cleanCacheBoundTotem = totemId;
  const geracao = cleanCacheGeracao;

  // O marcador só confirma o PRIMEIRO evento da página. Se esse evento já vier
  // `false`, o marcador é descartado e não engole um comando futuro.
  let primeiroEvento = true;

  const dbRef = ref(db, `${totemId}/clean_cache`);
  cleanCacheUnsub = onValue(dbRef, (snapshot) => {
    if (geracao !== cleanCacheGeracao || cleanCacheBoundTotem !== totemId)
      return;
    const acabouDeRecarregar = primeiroEvento && consumirMarcadorReload();
    primeiroEvento = false;

    if (!snapshot.val()) return;

    if (acabouDeRecarregar) {
      // Esta página É o reload pedido: confirma ao gestão e não recarrega de
      // novo. Se o write falhar, a flag fica `true` sem gerar novo evento — no
      // pior caso, um reload a mais no próximo boot do Chrome, nunca um loop.
      return desarmarFlag(db, totemId, geracao);
    }

    return aplicarOuAdiarReload(db, totemId, geracao);
  });
}

// totemId preenchido → totem do tipo EVENTO: a Home vem do doc exclusivo
// personalizaTotem/{totemId}. Se esse doc ainda não existe (tipo marcado no
// gestão mas Home nunca configurada), cai na config GLOBAL — melhor exibir a
// Home padrão do que uma tela em branco.
export async function loadHomeConfig(totemId = null) {
  if (totemId) {
    const totemRef = doc(db, COLLECTION_PERSONALIZA_TOTEM, totemId);
    const totemSnap = await getDoc(totemRef);
    if (totemSnap.exists()) {
      return totemSnap.data();
    }
  }
  const docRef = doc(db, "config", "home");
  const snap = await getDoc(docRef);
  if (snap.exists()) {
    return snap.data();
  }
  return { topo: null, galeria: [], botaoCor: null };
}

// Molduras fixas do evento — mesmo doc da Home personalizada
// (personalizaTotem/{totemId}), campo `molduras`. Sem doc, sem campo ou fora do
// tipo EVENTO a lista é vazia e o totem segue com as molduras de sempre.
// Diferente da Home, aqui NÃO há fallback para a config global: moldura fixa
// existe só quando o franqueado cadastra uma para este totem.
export async function loadMoldurasEvento(totemId) {
  if (!totemId) return [];
  const totemRef = doc(db, COLLECTION_PERSONALIZA_TOTEM, totemId);
  const snap = await getDoc(totemRef);
  if (!snap.exists()) return [];
  return normalizaMoldurasEvento(snap.data().molduras);
}

export { createUserWithEmailAndPassword, signInWithEmailAndPassword };
